module.exports = __webpack_public_path__ + "static/media/medium-dark.0b4b38a0.svg";